import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { stringify } from "../core/utils";

import * as ace from "brace";
import "ace-builds/webpack-resolver";
import AceEditor from "react-ace";
import "brace/mode/json";
import "brace/mode/xml";
import "brace/theme/github";

const NOOP = Function.prototype;

export default class RequestBodyEditor extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    getComponent: PropTypes.func.isRequired,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    errors: PropTypes.array,
    mode: PropTypes.string,
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    onChange: NOOP,
    userHasEditedBody: false,
    mode: "json",
    readOnly: true,
  };

  constructor(props, context) {
    super(props, context);
    this.ace = React.createRef();

    this.state = {
      value: stringify(props.value) || props.defaultValue,
      mode: "json",
    };

    // this is the glue that makes sure our initial value gets set as the
    // current request body value
    // TODO: achieve this in a selector instead
    props.onChange(props.value);
  }

  applyDefaultValue = (nextProps) => {
    const { onChange, defaultValue } = nextProps ? nextProps : this.props;

    this.setState({
      value: defaultValue,
    });

    return onChange(defaultValue);
  };

  onChange = (value) => {
    this.props.onChange(stringify(value));
  };

  onDomChange = (v) => {
    this.setState(
      {
        value: v,
      },
      () => this.onChange(v)
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.value !== nextProps.value &&
      nextProps.value !== this.state.value
    ) {
      this.setState({
        value: stringify(nextProps.value),
      });
    }

    if (
      this.props.mode !== nextProps.mode &&
      this.state.mode !== nextProps.mode
    ) {
      this.setState({ mode: nextProps.mode });
    }

    if (
      this.props.readOnly !== nextProps.readOnly ||
      this.state.readOnly !== nextProps.readOnly
    ) {
      this.setState({ readOnly: nextProps.readOnly });
    }

    if (!nextProps.value && nextProps.defaultValue && !!this.state.value) {
      // if new value is falsy, we have a default, AND the falsy value didn't
      // come from us originally
      this.applyDefaultValue(nextProps);
    }
  }

  render() {
    let { getComponent } = this.props;

    let { value, mode } = this.state;

    return (
      <div className="body-param">
        <AceEditor
          ref={this.ace}
          className={"body-param__text"}
          width="100%"
          value={value}
          mode={mode}
          theme="github"
          readOnly={this.state.readOnly}
          onChange={this.onDomChange}
          highlightActiveLine={true}
          editorProps={{ $blockScrolling: true }}
        />
      </div>
    );
  }
}
